import React, { FC } from 'react';

import styled, { CSSProp } from 'styled-components';

import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { assetStatusColors } from './consts';
import { Asset, AssetStatusColor } from './types';

type StatusColorIndicatorProps = {
  disabled?: boolean;
  color: AssetStatusColor;
  style?: CSSProp;
};

const StatusCellContainer = styled.div`
  align-items: center;
  display: flex;
  overflow: hidden;
`;

export const StatusColorIndicator = styled.div<StatusColorIndicatorProps>`
  background-color: ${({ color }) =>
    assetStatusColors[color] || assetStatusColors.default};
  border-radius: 2px;
  flex-shrink: 0;
  margin-right: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.35 : undefined)};
  height: 16px;
  width: 4px;
`;

const NoStatus = styled.div`
  ::before {
    content: '-';
  }
`;

const StatusCell: FC<{ asset: Asset; disabled?: boolean }> = ({
  asset,
  disabled,
}) => {
  if (!asset.status) {
    return <NoStatus />;
  }

  return (
    <StatusCellContainer>
      <StatusColorIndicator color={asset.status.color} disabled={disabled} />
      <OverflowTooltip
        getTargetProps={() => ({ style: { overflow: 'hidden' } })}
      >
        {asset.status.label}
      </OverflowTooltip>
    </StatusCellContainer>
  );
};

export default StatusCell;
